var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { XIcon } from '../icons/index.js';
import { useTrayContext } from './TrayContext.js';
export const TrayHeader = (_a) => {
    var { title, description, className, withBorder = false, children } = _a, rest = __rest(_a, ["title", "description", "className", "withBorder", "children"]);
    const { onClose } = useTrayContext();
    return (React.createElement("div", Object.assign({ className: clsx('px-4 py-5 sm:p-6', 'flex justify-between', !withBorder && 'pb-0 sm:pb-0', withBorder && 'border-b border-line-subdued', !description && 'items-center', !!description && 'items-start', className) }, rest),
        children || (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "text-center sm:mt-0 sm:text-start" },
                React.createElement("h3", { className: "text-content" }, title),
                description && (React.createElement("div", { className: "mt-1" },
                    React.createElement("p", { className: "text-content-subdued" }, description)))))),
        React.createElement("div", { className: "space-s-2 flex items-center" },
            React.createElement("button", { tabIndex: 0, type: "button", className: "bg-transparent rounded-md text-content-subdued hover:text-content-hovered focus:outline-none focus-visible:ring", onClick: onClose },
                React.createElement("span", { className: "sr-only" }, "Close"),
                React.createElement(XIcon, { className: "h-6 w-6", "aria-hidden": "true" })))));
};
//# sourceMappingURL=TrayHeader.js.map